<template>
  <div id="order-payment">
    <div class="page-title pt-5 pb-5 mb-0">
      <div class="container">
        <div class="column">
          <ul class="breadcrumbs" style="text-align: left">
            <li><router-link to="/">{{ $t('nav.home') }}</router-link></li>
            <li class="separator">&nbsp;</li>
            <li><router-link :to="{ name: 'cart' }">{{ $t('cart.cart') }}</router-link></li>
            <li class="separator">&nbsp;</li>
            <li>{{ $t('cart.checkout') }}</li>
          </ul>
        </div>
      </div>
    </div>


    <div class="container padding-top-1x padding-bottom-1x">
      <div class="col-12 border pt-30 pb-30 mb-40">
        <div class="sub-success">
          <p><span class="success">{{ $t('payment.checkout_counter')}}</span></p>
          <p class="mb-25" v-if="order.type !== 2">{{ $t('payment.sub_order1')}}
            <span class="time-red">
            <count-down
            v-if="paymentTimeoutTimestamp"
            :startTime="Date.now()"
            :endTime="paymentTimeoutTimestamp"
            :end_callback="endTimeDel"
            secondsTxt=""
          />
          </span>{{ $t('payment.sub_order2')}}</p>
        </div>
        <div class="b-b"></div>
        <div class="orders pt-25" v-if="order">
          <div>
            <div class="products-name mb-20" v-if="order.products.length">
              <div class="pr-20">{{ $t('checkout.merchandise_news') }}:</div>
              <div>
                <div class="order-item pb-10" v-for="item in order.products" :key="item.id">
                  {{ item.product_name }}
                </div>
              </div>
            </div>
            <div class="products-name">
              <div class="pr-20">{{ $t('order.shipping_info') }}:</div>
              <div class="order-item">
                <template v-if="order.shipping_method === 1">
                  <span class="pr-10">{{ order.shipping.warehouse_name }},</span>
                  <span class="pr-10">{{ order.shipping.warehouse_address }},</span>
                  <span class="pr-10">{{ order.shipping.consignee }},</span>
                  <span>{{ order.shipping.mobile }}</span>
                </template>
                <template v-else>
                  <span class="pr-10">{{ order.shipping.country }},</span>
                  <span class="pr-10">{{ order.shipping.line1 }},</span>
                  <span class="pr-10" v-if="order.shipping.line2">{{ order.shipping.line2 }},</span>
                  <span class="pr-10">{{ order.shipping.consignee }},</span>
                  <span>{{ order.shipping.mobile }}</span>
                </template>
              </div>
            </div>
          </div>
          <div>
            <el-button @click="goToOrder" size="mini" type="primary" plain round>{{ $t('user.my_orders') }} > </el-button>
          </div>
        </div>
      </div>
      <!--支付方式-->
      <el-tabs type="border-card" v-model="activeName" class="none-shadow" @tab-click="handleChangeMethod" v-if="order">

        <template v-if="order.type === 1 || order.type === 2">
          <!--paypal-->
          <!--
          <el-tab-pane v-if="order.currency !== 'CNY'" :label="$t('payment.paypal')" name="paypal">
            <div class="pays pt-15">
              <pay-pal-btn :order="order"></pay-pal-btn>
              <p style="text-align: center">
                <a href="javascript:;" @click="checkPay(1)" style="text-decoration: none">{{ $t('payment.has_the_payment_been_completed') }}</a>
              </p>
              <pay-table :order="order"></pay-table>
            </div>
          </el-tab-pane>
          -->

          <!--支付宝-->
          <el-tab-pane :label="$t('payment.alipay')" name="alipay">
            <div class="pays pt-15">
              <div id="alipay-button" class="text-center">
                <template v-if="isMobile">
                  <a :href="alipayUrl">
                    <el-button type="primary">
                      {{ $t('payment.go_to_alipay_app_for_payment') }}
                    </el-button>
                  </a>
                </template>
                <template v-else>

                  <div id="alipay-qrcode" v-if="alipayQrCode" class="text-center">
                    <section v-loading="payLoading" class="payment-container">
                      <div v-html="alipayQrCode"></div>
                      <!--<img :src="alipayQrCode"/>-->
                    </section>
                    {{ $t('payment.use_alipay_app_scan') }}
                  </div>
                </template>
              </div>
              <p style="text-align: center">
                <a href="javascript:;" @click="checkPay(2)" style="text-decoration: none">{{ $t('payment.has_the_payment_been_completed') }}</a>
              </p>
              <pay-table :order="order"></pay-table>
            </div>
          </el-tab-pane>

          <!--wx-->
          <el-tab-pane :label="$t('payment.wechatpay')" name="wechatpay">
            <div class="pays pt-15">
              <div id="wepay-container" class="text-center">

                <!--<template v-if="isMobile">-->
                  <!--<a :href="alipayUrl">-->
                    <!--<el-button type="primary">-->
                      <!--{{ $t('payment.go_to_alipay_app_for_payment') }}-->
                    <!--</el-button>-->
                  <!--</a>-->
                <!--</template>-->

                <!--<template v-else>-->
                  <section v-loading="payLoading" class="payment-container">
                    <!--<el-image src="/static/pay/wepay/WePayLogo.png"></el-image>-->
                    <div v-html="wepayQrCode"></div>
                    <div class=" mt-5">
                      <img src="/static/pay/wepay/desc.png" width="174" />
                    </div>
                  </section>
                <!--</template>-->

              </div>
              <p style="text-align: center">
                <a href="javascript:;" @click="checkPay(3)" style="text-decoration: none">{{ $t('payment.has_the_payment_been_completed') }}</a>
              </p>
              <pay-table :order="order"></pay-table>
            </div>
          </el-tab-pane>

          <!--fps-->
          <el-tab-pane label="FPS" name="fps">
            <div class="pays pt-15">
              <div id="fps-button" class="text-center">
                  <div id="fps-qrcode" v-if="fpsQrCode" class="text-center">
                    <section v-loading="payLoading" class="payment-container">
                      <div v-html="fpsQrCode"></div>
                      <!--<img :src="alipayQrCode"/>-->
                    </section>
                    {{ $t('payment.use_fps_scan') }}
                  </div>
              </div>
              <p style="text-align: center">
                <a href="javascript:;" @click="checkPay(2)" style="text-decoration: none">{{ $t('payment.has_the_payment_been_completed') }}</a>
              </p>
              <pay-table :order="order"></pay-table>
            </div>
          </el-tab-pane>


          <!--<el-tab-pane label="信用卡" name="allin">-->
            <!--<div class="pays pt-15">-->
              <!--<el-form label-position="left" label-width="5rem"-->
                       <!--ref="creditCardForm" :rules="creditCardFormRules"-->
                       <!--:model="creditCardForm"  :class="isMobile ? 'w-100' : 'w-50'">-->

                <!--<el-form-item label="名字" prop="billingLastName">-->
                  <!--<el-input v-model.trim="creditCardForm.billingLastName" name="cardHolder"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="姓氏" prop="billingFirstName">-->
                  <!--<el-input v-model.trim="creditCardForm.billingFirstName" name="cardHolder"></el-input>-->
                <!--</el-form-item>-->
                <!--&lt;!&ndash;<el-form-item label="持卡人" prop="cardHolder">&ndash;&gt;-->
                  <!--&lt;!&ndash;<el-input v-model.trim="creditCardForm.cardHolder" name="cardHolder"></el-input>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-form-item>&ndash;&gt;-->
                <!--<el-form-item label="卡号" prop="acctNo">-->
                  <!--<el-input v-model.trim="creditCardForm.acctNo" name="acctNo"></el-input>-->
                <!--</el-form-item >-->
                <!--<el-form-item label="有效期" class="date-picker" prop="expiryMonth">-->
                  <!--<el-date-picker-->
                      <!--v-model="creditCardForm.expiryMonth"-->
                      <!--type="month"-->
                      <!--value-format="yyyy-MM">-->
                  <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="CVV" prop="acctCvv">-->
                  <!--<el-input v-model.trim="creditCardForm.acctCvv" name="expiryYear"></el-input>-->
                <!--</el-form-item>-->
                <!--&lt;!&ndash;<el-divider>账单</el-divider>&ndash;&gt;-->
                <!--&lt;!&ndash;<el-form-item label="地区">&ndash;&gt;-->
                  <!--&lt;!&ndash;<el-input v-model.trim="creditCardForm.districtId" name="cardHolder"></el-input>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-form-item>&ndash;&gt;-->
                <!--&lt;!&ndash;<el-form-item label="地址">&ndash;&gt;-->
                  <!--&lt;!&ndash;<el-input v-model.trim="creditCardForm.billingAddress1" name="cardHolder"></el-input>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-form-item>&ndash;&gt;-->
                <!--&lt;!&ndash;<el-form-item label="电话">&ndash;&gt;-->
                  <!--&lt;!&ndash;<el-input v-model.trim="creditCardForm.cardHolder" name="cardHolder" type="number"></el-input>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-form-item>&ndash;&gt;-->
                <!--<el-form-item class="col-12" style="text-align: center" label-width="0">-->
                  <!--<el-button class="btn btn-primary margin-right-none" @click="allinPay">{{ $t('order.to_pay') }}-->
                  <!--</el-button>-->
                <!--</el-form-item>-->
              <!--</el-form>-->
              <!--<p style="text-align: center">-->
                <!--<a href="javascript:;" @click="checkPay(2)" style="text-decoration: none">{{ $t('payment.has_the_payment_been_completed') }}</a>-->
              <!--</p>-->
              <!--<pay-table :order="order"></pay-table>-->
            <!--</div>-->
          <!--</el-tab-pane>-->
        </template>
        <template v-if="order.type === 3">
          <el-tab-pane label="Yuansfer" name="yuansfer">
            <div class="pays pt-15">
              <div class="paymment-method-selector" :class="isMobile ? 'pt-10' : ''">
                <el-radio-group v-model="vendor">
                  <div class="row" :class="isMobile ? 'pay-phone' : ''">
                    <!--<el-radio label="paypal" class="col-4">-->
                      <!--<img :src="paypalLogo" alt="PayPal Acceptance Mark">-->
                    <!--</el-radio>-->
                    <el-radio label="alipay" >
                      <img :src="alipayLogo" :alt="$t('payment.alipay')" :style="isMobile ? 'min-width: 100px;max-width: 100px' : ''" />
                    </el-radio>
                    <!--<el-radio label="wechatpay" class="col">-->
                      <!--<img :src="wechapayLogo" :alt="$t('payment.wechatpay')" />-->
                    <!--</el-radio>-->
                    <!--<el-radio label="unionpay" class="col-4">-->
                      <!--<img :src="unionpayLogo" :alt="$t('payment.wechatpay')" />-->
                    <!--</el-radio>-->
                  </div>

                </el-radio-group>
              </div>

              <el-button :disabled="!vendor" @click="yuansferPay">{{ $t('order.to_pay')}}</el-button>
              <p style="text-align: center">
                <a href="javascript:;" @click="checkYuansferPay()" style="text-decoration: none">{{ $t('payment.has_the_payment_been_completed') }}</a>
              </p>
              <pay-table :order="order"></pay-table>
            </div>
          </el-tab-pane>
        </template>

      </el-tabs>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import PayTable from '@/components/order/PayTable.vue';
  import PayPalBtn from '@/components/order/PayPalBtn.vue';
  import alipayLogo from '@/assets/payments/alipay.png';
  import wechapayLogo from '@/assets/payments/wechatpay.png';
  // import unionpayLogo from '@/assets/payments/unionpay.png';
  import paypalLogo from '@/assets/payments/paypal.png';
  import moment from 'moment';
  import CountDown from 'vue2-countdown';
  // import appConfig from '../../app.config';

  /* globals, process */

  export default {
    name: 'OrderPayment',
    data() {
      return {
        env: process.env.NODE_ENV,
        order: null,
        alipayQrCode: null,
        fpsQrCode: null,
        wepayQrCode: null,
        activeName: 'alipay',
        restore: 0,
        payLoading: false,
        alipayLogo,
        wechapayLogo,
        paypalLogo,
        // unionpayLogo,
        vendor: null,
        alipayUrl: '',
        wechatUrl: '',
        creditCardForm: {
          cardHolder: '',
          acctNo: '',
          acctCvv: '',
          expiryMonth: '',
          expiryYear: '',
          billingLastName: '',
          billingFirstName: '',
        },
        creditCardFormRules: {
          cardHolder: { required: true, message: this.$t('shipping_address.rules.label_reduired'), trigger: 'blur' },
          acctNo: { required: true, message: this.$t('shipping_address.rules.consignee_reduired'), trigger: 'blur' },
          acctCvv: { required: true, message: this.$t('shipping_address.rules.consignee_reduired'), trigger: 'blur' },
          expiryMonth: { required: true, message: this.$t('shipping_address.rules.consignee_reduired'), trigger: 'blur' },
          billingLastName: { required: true, message: this.$t('shipping_address.rules.consignee_reduired'), trigger: 'blur' },
          billingFirstName: { required: true, message: this.$t('shipping_address.rules.consignee_reduired'), trigger: 'blur' },
        },
      };
    },
    mounted() {
      this.getOrder();
      this.$echo.private(`order.refersh.${this.$route.params.id}`)
        .listen('.order.paid', () => {
          this.$notify({
            type: 'success',
            title: this.$t('payment.order_paid_successful'),
          });
          this.goToOrder();
      });

      this.$api.user.creditCard().then(({ data: response }) => {
        // console.log(response.data);
        this.creditCardForm = { ...response.data };
      });
    },
    computed: {
      ...mapGetters([
        'isMobile',
      ]),
      paymentTimeoutTimestamp() {
        if (this.order) {
          return moment(this.order.payment_timeout_date).unix();
        }
        return false;
      },
    },
    methods: {
      yuansferPay() {
        if (this.order) {
          this.$api.yuansferpay.makepay({ order_id: this.order.id, vendor: this.vendor }).then(({ data: response }) => {
            window.location.href = response;
          }).catch((error) => {
            if (error.response) {
              this.$notify({
                type: 'warning',
                message: error.response.data.message,
              });
            }
          });
        }
      },
      checkYuansferPay() {
        if (this.order) {
          this.$api.yuansferpay.check(this.order.id).then(({ data: response }) => {
            this.$notify({
              type: response.status === 0 ? 'danger' : 'success',
              message: response.message,
            });
            if (response.status !== 0) {
              this.goToOrder();
            }
          });
        }
      },
      checkPay() {
        if (this.order) {
          // this.$api.paypalv2.orderCheck(this.order.id).then(({ data: response }) => {
          //   this.$notify({
          //     type: response.status === 0 ? 'danger' : 'success',
          //     message: response.message,
          //   });
          //   if (response.status !== 0) {
          //     this.goToOrder();
          //   }
          // });
          this.$api.order.orderCheck(this.order.id).then(({ data: response }) => {
            this.$notify({
              type: response.status === 0 ? 'danger' : 'success',
              message: response.message,
            });
            if (response.status !== 0) {
              this.goToOrder();
            }
          });
        }
      },
      endTimeDel() {
        const params = {
          orderId: this.order.id,
          restore: this.restore,
        };
        this.$store.dispatch('deleteOrder', params)
          .then(() => {
            this.$notify({
              type: 'success',
              title: this.$t('payment.order_timeout'),
            });
          })
          .catch((error) => {
            if (error.response) {
              this.$notify({
                type: 'danger',
                message: error.response.data.message,
              });
            }
        });
      },
      goToOrder() {
        this.$router.push({ name: 'order-detail', params: { id: this.order.id } });
      },
      getOrder() {
        this.$api.order.getById(this.$route.params.id).then(({ data: response }) => {
          this.order = response.data;
          if (this.order.status !== 1) {
            this.$notify({
              type: 'warning',
              title: this.$t('payment.order_not_pay'),
            });
            this.$router.push({ name: 'order-detail', params: { id: this.order.id } });
          } else if (this.order.currency === 'CNY') {
            this.handleChangeMethod({ name: 'alipay' });
            this.activeName = 'alipay';
          } else {
            this.handleChangeMethod({ name: 'alipay' });
            this.activeName = 'alipay';
          }
          if (this.order.type === 3) {
            this.activeName = 'yuansfer';
          }
        });
      },
      handleChangeMethod(tab) {
        const tabName = tab.name;
        if (tabName === 'alipay' && !this.alipayQrCode) {
          this.$nextTick(() => {
            this.payLoading = true;
            this.$api.qfpay.makepay({ order_id: this.order.id, payment: 'alipay' })
              .then(({ data: response }) => {
                if (this.isMobile) {
                  this.alipayUrl = response.pay_url;
                } else {
                  this.alipayQrCode = response;
                }
              })
              .catch(() => {
                //
              })
              .finally(() => {
                this.payLoading = false;
            });
          });
        }

        if (tabName === 'wechatpay' && !this.wepayQrCode) {
          this.$nextTick(() => {
            this.payLoading = true;
            this.$api.qfpay.makepay({ order_id: this.order.id, payment: 'wechat' })
              .then(({ data: response }) => {
                // if (this.isMobile) {
                //   this.wechatUrl = response.pay_url;
                // } else {
                this.wepayQrCode = response;
                // }
              })
              .catch(() => {
              })
              .finally(() => { this.payLoading = false; });
          });
        }

        if (tabName === 'fps' && !this.fpsQrCode) {
          this.$nextTick(() => {
            this.payLoading = true;
            this.$api.qfpay.makepay({ order_id: this.order.id, payment: 'fps' })
              .then(({ data: response }) => {
                this.fpsQrCode = response;
              })
              .catch(() => {
              })
              .finally(() => { this.payLoading = false; });
          });
        }
      },
      allinPay() {
        this.$refs.creditCardForm.validate((valid) => {
          if (valid) {
            // const exp
            const params = { ...this.creditCardForm, order_id: this.order.id, payment: 'allin' };
            this.payLoading = true;
            this.$api.qfpay.makepay(params)
              .then(({ data: response }) => {
                window.open(response.payUrl);
              })
              .catch(() => {
              })
              .finally(() => { this.payLoading = false; });
          }
        });
      },
    },
    components: {
      CountDown,
      PayPalBtn,
      PayTable,
    },
  };
</script>

<style lang="scss">
  @import "../../styles/helpers/variables";
  .el-month-table a {
    text-decoration: none!important;
  }
  #order-payment {
    font-size: 15px;
    .b-b {
      border-bottom: 1px solid #cccccc;
    }
    .none-shadow {
      box-shadow: none;
    }
    .text-center {
      text-align: center;
    }
    .sub-success {
      p{
        display: flex;
        align-items: center;
        .auto-icon {
          font-size: 26px;
          color: #67C23A;
        }
        .success {
          padding: 0 5px;
          font-size: 22px;
          font-weight: bold;
        }
      }
      .time-red {
        color: #ff5252;
        p {
          margin-bottom: 0;
        }
      }
    }

    .pays {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .card-body {
        th,td {
          border: none;
        }
        td {
          float: right;
        }
      }
      .date-picker {
        .el-input__inner {
          padding-left: 40px;
        }
      }
    }
    .orders {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: nowrap;
      .products-name {
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-start;
        .order-item {
          color: $gray-darker;
        }
        .next-n {

        }
      }
    }
  }

  // peyment_method
  .paymment-method-selector {
    .pay-phone {
      display: flex;
      flex-direction: column;
      label {
        min-height: 60px;
        span {
          img {
            min-width: 120px;
            max-width: 120px;
          }
        }
      }
    }
    .el-radio {
      .el-radio__label {
        padding-left: 20px;
        img {
          /*height: 50px;*/
          /*width: auto;*/
        }
      }
    }
  }
</style>
